<template>
  <div class="col-md-12 text-center" style="margin-top: 1em">
    <div>
      <h6>
        <p
          style="margin-top: 1em"
          v-if="appointment.latestStatus == 'InProgress'"
        >{{ $t("message.Appointment is in progress") }}</p>
        <p
          style="margin-top: 1em"
          v-if="appointment.latestStatus != 'InProgress'"
        >{{ appointment.latestStatus }}</p>
      </h6>

      <div class="col-12 text-left" style="margin-top: 2em">
        <span style="font-weight: 600">{{ $t("message.Date & Time") }}</span>
        <div
          class="col-12"
          v-if="appointment.scheduledTimestamp"
        >{{ getFormattedDate(appointment.scheduledTimestamp.start) }} at {{ getFormattedTime(appointment.scheduledTimestamp.start) }} : 00</div>
        <div
          class="col-12"
          v-if="!appointment.scheduledTimestamp"
        >{{ getFormattedDate(appointment.created) }}</div>
      </div>

      <div class="col-12 text-left" style="margin-top: 2em" v-if="appointment.provider">
        <span style="font-weight: 600">{{ $t("message.Doctor:") }}</span>
        <div class="col-12">
          <span
            style="font-weight: 500"
          >Dr. {{ appointment.provider.firstName }} {{ appointment.provider.lastName }}</span>
          <br />
        </div>
      </div>

      <div class="col-12 text-left" style="margin-top: 2em">
        <span style="font-weight: 600">{{ $t("message.Coordinator:") }}</span>
        <div class="col-12">
          <span
            style="font-weight: 500"
          >{{ appointment.careCoordinator.firstName }} {{ appointment.careCoordinator.lastName }}</span>
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "view-appointment",

  computed: {
    appointment() {
      return this.$store.state.selectedAppointment;
    },
  },

  methods: {
    getFormattedDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
  },
};
</script>
